import { Routes } from '@angular/router';
import { ScaffoldComponent } from './layouts/pages/scaffold/scaffold.component';

export const routes: Routes = [
  {
    path: '',
    component: ScaffoldComponent,
    children: [
      { path: 'destaques', redirectTo: 'post' },
      { path: 'mais', redirectTo: 'post' },
      { path: 'equipe', redirectTo: 'team' },
      { path: 'sobre', redirectTo: 'about' },
      {
        path: '',
        loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule),
      },
      { path: 'about', loadChildren: () => import('./modules/about/about.module').then((m) => m.AboutModule) },
      { path: 'team', loadChildren: () => import('./modules/team/team.module').then((m) => m.TeamModule) },
      {
        path: 'post',
        loadChildren: () => import('./modules/post/post.module').then((m) => m.PostModule),
      },
    ],
  },
  { path: '', loadChildren: () => import('./modules/code/code.module').then((m) => m.CodeModule) },
  { path: '**', redirectTo: '' },
];
